import { Navigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { useAuth } from "@/context/AuthContext";
import { isDriveEmployee } from "@/lib/api";
import { ChatBox } from "@/components/ChatBox";
import { useTranslation } from "react-i18next";

export default function CompanyChat() {
  const { user } = useAuth();
  const { t } = useTranslation();
  if (!isDriveEmployee(user)) return <Navigate to="/" replace />;
  return (
    <div className="space-y-4" data-testid="company-chat-page">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight">{t("chatPage.companyTitle")}</h1>
        <p className="text-sm text-slate-500">{t("chatPage.companySubtitle")}</p>
      </div>
      <Card className="overflow-hidden">
        <ChatBox room="company" />
      </Card>
    </div>
  );
}
